import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-dashboard-name-renderer',
    templateUrl: './dashboard-name-renderer.component.html',
    styleUrls: ['./dashboard-name-renderer.component.scss']
})
export class DashboardNameRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;
    value: string;
    isAbandoned: boolean;

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted;
        this.isAbandoned = this.params.context?.contextUtil?.isDashboardAbandoned(this.params.data.DashboardKey);
        this.params.eGridCell.addEventListener("keypress", (event) => this.onDashboardClick(event));
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted;
        this.isAbandoned = this.params.context?.contextUtil?.isDashboardAbandoned(this.params.data.DashboardKey);
        return true;
    }

    onDashboardClick(event: Event) {
        event.preventDefault();
        if (typeof this.params['dashboardClicked'] === 'function')
            this.params['dashboardClicked'](this.params.node.id);
    }
}
